import { LandEvent, useSyncLandEventStatus, useUpcomingLandEvent } from '~/components/Land/Event';
import { EndedLandEventHero } from '~/components/Land/Event/Hero/Ended/EndedLandEventHero';
import { InProgressLandEventHero } from '~/components/Land/Event/Hero/InProgress/InProgressLandEventHero';
import { UpcomingLandEventHero } from '~/components/Land/Event/Hero/Upcoming/UpcomingLandEventHero';

export type LandEventHeroProps = {
  id: LandEvent['week'];
  className?: string;
};

const landEventHeroMap = {
  UPCOMING: UpcomingLandEventHero,
  IN_PROGRESS: InProgressLandEventHero,
  END: EndedLandEventHero,
};
export const LandEventHero = ({ id, ...props }: LandEventHeroProps) => {
  const status = useSyncLandEventStatus(id);
  const upcoming = useUpcomingLandEvent({ enabled: status === 'END' });
  const Component = landEventHeroMap[status];
  return status === 'END' && upcoming ? (
    <UpcomingLandEventHero id={upcoming.week} {...props} />
  ) : (
    <Component id={id} {...props} />
  );
};
